import { GarudaResponse } from "../../models/events";
import { update } from "../../../../../common/state/Slices/InstalledGadgetsSlice";
import { useAppDispatch } from "../../../../../common/state/hooks";
import { GadgetInstallationCompletedBody, InstallationStatus } from "../../models/body";
import { updateForAllDevice } from "../../../../../common/state/Slices/InstallOnAllDeviceSlice";

export const useGadgetInstallationCompletionHandler = () => {
    const dispatch = useAppDispatch();

    const handleGadgetInstallationComplete = (response: GarudaResponse) => {
        const body = response.body as GadgetInstallationCompletedBody;
        const gadgetId = body.gadgetId;
        dispatch(
            update(
                { 
                    sourceDeviceId: body.sourceDeviceId,
                    gadgetId,
                    status: body.status,
                    progress: 100
                }
            )
        );

        dispatch(
            updateForAllDevice({
                gadgetId,
                deviceId: body.sourceDeviceId,
                isSuccess: body.status === InstallationStatus.SUCCESS
            })
        );
    };

    return {
        handleGadgetInstallationComplete
    }
}